/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Previous_MarkerInputs */



/**
* | output |
* | --- |
* | "Previous Marker" |
*
* @param {Shortcut_Keys_Name_Previous_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_previous_marker = /** @type {((inputs?: Shortcut_Keys_Name_Previous_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Previous_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marqueur precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriger Marker")
	if (locale === "it") return /** @type {LocalizedString} */ ("Marcatore precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущий маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcador anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上一个标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のマーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला मार्कर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcador anterior")
	return /** @type {LocalizedString} */ ("Previous Marker")
});